// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TgKB","left":"styles_left__1HCsM","right":"styles_right__1f1-G","alert":"styles_alert__1wFXJ"};